import React, { useState } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { Button, Radio, FormControlLabel } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";

const LocationSelection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { type, pickup, dropoff, pickupCoordinates, dropoffCoordinates } =
    location.state;

  const [newLocation, setNewLocation] = useState("");
  const [newLocations, setNewLocations] = useState([]);

  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const handleSelectLocation = async (value) => {
    try {
      const results = await geocodeByAddress(value);
      if (results.length === 0) {
        console.error("No results found for this address");
        return;
      }

      // Get latitude and longitude
      const ll = await getLatLng(results[0]);
      console.log("Latitude and Longitude:", ll);

      setNewLocation(value);
      setSelectedLocation(value);
      setCoordinates(ll);
    } catch (error) {
      console.error("Error getting coordinates:", error);
    }
  };

  const handleSelect = () => {
    const updatedAddress = selectedLocation || "Current Location";

    if (type === "pickup") {
      navigate("/courier/60f83c2d884dac2155afe254", {
        state: {
          pickup: updatedAddress,
          dropoff,
          pickupCoordinates: coordinates,
          dropoffCoordinates,
        },
      });
    } else {
      navigate("/courier/60f83c2d884dac2155afe254", {
        state: {
          pickup,
          dropoff: updatedAddress,
          pickupCoordinates,
          dropoffCoordinates: coordinates,
        },
      });
    }
  };

  return (
    <div className="b-login-page">
      <div className="b-contain">
        <h4 style={{ color: "black" }}>
          {type === "dropoff" ? "Dropoff Address" : "Pickup Address"}
        </h4>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p>Select or add a location</p>
          <Button
            onClick={() => setShowSearch(true)}
            style={{
              backgroundColor: "transparent",
              border: "none",
              position: "relative",
              width: "30px", // Adjust size as needed
              height: "30px", // Adjust size as needed
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 0,
              cursor: "pointer",
            }}
          >
            <div
              style={{
                backgroundColor: "red",
                borderRadius: "50%",
                width: "20px", // Circle diameter
                height: "20px", // Circle diameter
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AddIcon style={{ color: "white" }} />
            </div>
          </Button>
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <FormControlLabel
            control={
              <Radio
                checked={selectedLocation === "Current Location"}
                onChange={() => {
                  setSelectedLocation("Current Location");
                  setNewLocation("");
                }}
              />
            }
            label="Current Location"
          />
          {locations.map((loc, index) => (
            <FormControlLabel
              key={index}
              control={
                <Radio
                  checked={selectedLocation === loc}
                  onChange={() => setSelectedLocation(loc)}
                />
              }
              label={loc}
            />
          ))}
          {(selected) => {
            setNewLocations((prev) => [...prev, selected]);
            handleSelectLocation(selected);
            setNewLocation("");
          }}
          {newLocations.map((loc, index) => (
            <FormControlLabel
              key={index}
              control={
                <Radio
                  checked={selectedLocation === loc}
                  onChange={() => setSelectedLocation(loc)}
                />
              }
              label={loc}
            />
          ))}
          {/* {newLocation && (
          <FormControlLabel
            control={
              <Radio
                checked={selectedLocation === newLocation}
                onChange={() => setSelectedLocation(newLocation)}
              />
            }
            label={newLocation}
          />
        )} */}
        </div>

        {showSearch && (
          <div>
            <PlacesAutocomplete
              value={newLocation}
              onChange={setNewLocation}
              onSelect={(selected) => {
                setNewLocations((prev) => [...prev, selected]); // Append new location
                handleSelectLocation(selected); // Call your existing function
                setNewLocation(""); // Clear input field after selection
              }}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div>
                  <input
                    {...getInputProps({
                      placeholder: "Search Places ...",
                      className: "location-search-input",
                    })}
                  />
                  <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion) => {
                      const className = suggestion.active
                        ? "suggestion-item suggestion-item--active" // Apply both classes if active
                        : "suggestion-item"; // Apply the base class

                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                          })}
                          key={suggestion.placeId}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}

                    {/* {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? "suggestion-item--active"
                      : "suggestion-item";
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };

                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                        key={suggestion.placeId}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })} */}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          </div>
        )}

        <br></br>
        <Button
          disabled={!selectedLocation}
          className="b-login-btn"
          size="small"
          onClick={handleSelect}
        >
          Select
        </Button>
        {/* </div> */}
      </div>
    </div>
  );

  // return (
  //   <div className="select-vehicle-container">
  //     <h1>Locations</h1>
  //     {/* <p>Select or add a location:</p>
  //     <Button onClick={() => setShowSearch(true)}>
  //       <AddIcon />
  //     </Button> */}
  //     <div style={{ display: "flex", alignItems: "center" }}>
  //       <p style={{ marginRight: "10px" }}>Select or add a location:</p>
  //       <Button
  //         onClick={() => setShowSearch(true)}
  //         style={{
  //           backgroundColor: "transparent",
  //           border: "none",
  //           position: "relative",
  //           width: "30px", // Adjust size as needed
  //           height: "30px", // Adjust size as needed
  //           borderRadius: "50%",
  //           display: "flex",
  //           justifyContent: "center",
  //           alignItems: "center",
  //           padding: 0,
  //           cursor: "pointer",
  //         }}
  //       >
  //         <div
  //           style={{
  //             backgroundColor: "red",
  //             borderRadius: "50%",
  //             width: "20px", // Circle diameter
  //             height: "20px", // Circle diameter
  //             display: "flex",
  //             justifyContent: "center",
  //             alignItems: "center",
  //           }}
  //         >
  //           <AddIcon style={{ color: "white" }} />
  //         </div>
  //       </Button>
  //     </div>

  //     {/* <FormControlLabel
  //       control={
  //         <Radio
  //           checked={selectedLocation === "Current Location"}
  //           onChange={() => {
  //             setSelectedLocation("Current Location");
  //             setNewLocation("");
  //           }}
  //         />
  //       }
  //       label="Current Location"
  //     />

  //     {locations.map((loc, index) => (
  //       <FormControlLabel
  //         key={index}
  //         control={
  //           <Radio
  //             checked={selectedLocation === loc}
  //             onChange={() => setSelectedLocation(loc)}
  //           />
  //         }
  //         label={loc}
  //       />
  //     ))} */}
  //     <div style={{ display: "flex", flexDirection: "column" }}>
  //       <FormControlLabel
  //         control={
  //           <Radio
  //             checked={selectedLocation === "Current Location"}
  //             onChange={() => {
  //               setSelectedLocation("Current Location");
  //               setNewLocation("");
  //             }}
  //           />
  //         }
  //         label="Current Location"
  //       />

  //       {locations.map((loc, index) => (
  //         <FormControlLabel
  //           key={index}
  //           control={
  //             <Radio
  //               checked={selectedLocation === loc}
  //               onChange={() => setSelectedLocation(loc)}
  //             />
  //           }
  //           label={loc}
  //         />
  //       ))}

  //       {newLocation && (
  //         <FormControlLabel
  //           control={
  //             <Radio
  //               checked={selectedLocation === newLocation}
  //               onChange={() => setSelectedLocation(newLocation)}
  //             />
  //           }
  //           label={newLocation}
  //         />
  //       )}
  //     </div>

  //     {showSearch && (
  //       <div>
  //         <PlacesAutocomplete
  //           value={newLocation}
  //           onChange={setNewLocation}
  //           onSelect={handleSelectLocation}
  //         >
  //           {({
  //             getInputProps,
  //             suggestions,
  //             getSuggestionItemProps,
  //             loading,
  //           }) => (
  //             <div>
  //               <input
  //                 {...getInputProps({
  //                   placeholder: "Search Places ...",
  //                   className: "location-search-input",
  //                 })}
  //               />
  //               <div className="autocomplete-dropdown-container">
  //                 {loading && <div>Loading...</div>}
  //                 {suggestions.map((suggestion) => {
  //                   const className = suggestion.active
  //                     ? "suggestion-item--active"
  //                     : "suggestion-item";
  //                   const style = suggestion.active
  //                     ? { backgroundColor: "#fafafa", cursor: "pointer" }
  //                     : { backgroundColor: "#ffffff", cursor: "pointer" };

  //                   return (
  //                     <div
  //                       {...getSuggestionItemProps(suggestion, {
  //                         className,
  //                         style,
  //                       })}
  //                       key={suggestion.placeId}
  //                     >
  //                       <span>{suggestion.description}</span>
  //                     </div>
  //                   );
  //                 })}
  //               </div>
  //               <Button onClick={addLocation}>Add</Button>
  //             </div>
  //           )}
  //         </PlacesAutocomplete>
  //       </div>
  //     )}
  //     <Button onClick={handleSelect} disabled={!selectedLocation}>
  //       Select
  //     </Button>
  //   </div>
  // );
};

export default LocationSelection;
